// MBD Auth Revamp pack — standalone. Auth pages do not load the "site" pack,
// so this pack owns everything they need: Rails UJS (data-method links,
// disable_with) plus the password behaviors.

import Rails from "@rails/ujs";
import "../stylesheets/auth/main.scss";

Rails.start();

// Password visibility toggle
document.addEventListener("click", (event) => {
  const toggle = event.target.closest("[data-auth-toggle-password]");
  if (!toggle) return;
  const input = document.getElementById("password-input");
  if (!input) return;
  const show = input.type === "password";
  input.type = show ? "text" : "password";
  toggle.querySelector(".icon-eye-hide").classList.toggle("d-none", show);
  toggle.querySelector(".icon-eye-show").classList.toggle("d-none", !show);
});

// Live password rule checker (reset password page). Mirrors the rules
// enforced by the legacy portal so accepted passwords stay identical.
document.addEventListener("input", (event) => {
  const field = event.target.closest(".js-password-checker");
  if (!field) return;
  const value = field.value;

  const checks = {
    "pw-error1": !/\s/.test(value),
    "pw-error2": /[A-Z]/.test(value),
    "pw-error3": /[a-z]/.test(value),
    "pw-error4": /[0-9]/.test(value),
    "pw-error5": /[~`!@#$%^&*()\-+={}\[\]|\\:;"'<>,.?/_₹]/.test(value),
    "pw-error6": /^.{8,100}$/.test(value),
  };

  let allValid = true;
  Object.entries(checks).forEach(([klass, ok]) => {
    document.querySelectorAll(`.${klass}`).forEach((el) => {
      el.classList.toggle("text-danger", !ok);
      el.classList.toggle("text-success", ok);
    });
    if (!ok) allValid = false;
  });

  document.querySelectorAll(".js-password-submit").forEach((button) => {
    button.disabled = !allValid;
  });
});
